<template>
<div>
    <data-view-sidebar-upload-file-visa-requirement :isSidebarActive="addNewDataSidebarUploadFileVisaRequirement" @closeSidebar="toggleDataSidebarUploadFileVisaRequirement" :data="sidebarDataUploadFileVisaRequirement" v-on:closeSidebarSuccess="updateCardCheckListDocuments" />
    <data-view-sidebar-visa-requirement :isSidebarActive="addNewDataSidebarVisaRequirement" @closeSidebar="toggleDataSidebarVisaRequirement" :data="sidebarDataVisaRequirement" v-on:closeSidebarSuccess="updateCardCheckListDocuments" />
    <data-view-sidebar-update-visa-requirement :isSidebarActive="addNewDataSidebarUpdateVisaRequirement" @closeSidebar="toggleDataSidebarUpdateVisaRequirement" :data="sidebarDataUpdateVisaRequirement" v-on:closeSidebarSuccess="updateCardCheckListDocuments" />

    <vx-card title="Checklist Documentos" iconCard="ArchiveIcon" class="my-4">
      <template slot="no-body">
        <p class="pt-2 pl-8 pr-6">Este es el listado de documentos que debes proporcionar para llevar a cabo exitosamente tu proceso migratorio.</p>
      </template>
      <vs-divider class="m-0 p-0"/>
      <vs-table ref="table" :data="visaRequirements" stripe>

        <template slot="thead">
          <vs-th sort-key="name_visa_document_type" class="font-semibold text-base">Documento</vs-th>
          <vs-th sort-key="full_name_family" class="font-semibold text-base">Pertenece a</vs-th>
          <vs-th sort-key="expiration_date_visa_requirement" class="font-semibold text-base">Fecha Vencimiento</vs-th>
          <vs-th class="font-semibold text-base">Estatus</vs-th>
          <vs-th class="font-semibold text-base">Acciones</vs-th>
        </template>
        <template slot-scope="{data}">
          <tbody >
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :state="(tr.status_visa_requirement === 'Aceptado') ? 'success' : (tr.status_visa_requirement === 'Rechazado') ? 'danger' : (tr.status_visa_requirement === 'Cargado') ? 'warning' : null">
              <vs-td>
                <p class="font-medium">{{ tr.name_visa_document_type }}</p>
              </vs-td>
              <vs-td>
                <p class="product-category1">{{ tr.full_name_family  }}</p>
              </vs-td>
              <vs-td>
                <!-- <p class="product-category1">{{ tr.expired_date }} ({{ tr.dias }}) <feather-icon icon="AlertCircleIcon" svgClasses="h-6 w-6 mr-4 cursor-pointer" :class="{'text-transparent':tr.dias >= 60,'text-danger':tr.dias <= 30, 'text-warning':tr.dias < 60 && tr.dias >30}" v-if="tr.dias > 0"/> -->
                <p class="product-category1">{{ tr.expiration_date_visa_requirement | formato_fecha3 }}</p>
                <span v-if="tr.expiration_date_visa_requirement">({{ getRemainingDays(tr.expiration_date_visa_requirement) }})</span>
              </vs-td>
              <vs-td>
                  <p class="product-category">{{ tr.status_visa_requirement  }}</p>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <div v-if="tr.files" class="button-alignment">
                  <vs-button class="w-8 h-8 hover:text-success" title="Agregar Archivo" color="dark" type="flat" icon-pack="feather" icon="icon-paperclip" @click.stop="uploadFileVisaRequirement(tr)" :disabled="tr.files.length !== 0"></vs-button>
                  <vs-button class="w-8 h-8 hover:text-success" title="Descargar Archivo" color="dark" type="flat" icon-pack="feather" icon="icon-download" @click.stop="downloadDocumentFiles(tr)" :disabled="tr.files.length === 0"></vs-button>
                  <vs-button class="w-8 h-8 hover:text-success" title="Borrar Archivo" color="dark" type="flat" icon-pack="feather" icon="icon-trash" @click.stop="confirmDeleteFileVisaRequirement(tr)" :disabled="tr.files.length === 0"></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <div class="flex flex-wrap-reverse items-center data-list-btn-container">
        <vs-button type="border" icon-pack="feather" icon="icon-plus" class="my-4" @click="addNewVisaRequirements()">
          Agregar documento adicional
        </vs-button>
      </div>
    </vx-card>
</div>
</template>

<script>
import axios from '@/axios.js'
import VisaRequirementViewSidebar from '../sidebars/VisaRequirementViewSidebar.vue'
import UpdateVisaRequirementViewSidebar from '../sidebars/UpdateVisaRequirementViewSidebar.vue'
import UploadFileVisaRequirementViewSidebar from '../sidebars/UploadFileVisaRequirementViewSidebar.vue'
export default {
  components: {
    'DataViewSidebarVisaRequirement': VisaRequirementViewSidebar,
    'DataViewSidebarUpdateVisaRequirement': UpdateVisaRequirementViewSidebar,
    'DataViewSidebarUploadFileVisaRequirement': UploadFileVisaRequirementViewSidebar
  },
  data () {
    return {
      id_client: null,
      userInfo: null,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      // Data Sidebar Upload File Visa Requirement
      addNewDataSidebarUploadFileVisaRequirement: false,
      sidebarDataUploadFileVisaRequirement: {},
      // Data Sidebar Visa Requirement
      addNewDataSidebarVisaRequirement: false,
      addNewDataSidebarUpdateVisaRequirement: false,
      sidebarDataVisaRequirement: {},
      sidebarDataUpdateVisaRequirement: {}
    }
  },
  computed: {
    addedServicesForAClientInmigration () {
      const addedServicesForAClientInmigration = this.$store.state.addedServicesForAClientInmigration
      return addedServicesForAClientInmigration.sort((a, b) => Date.parse(b.created_at_added_service) - Date.parse(a.created_at_added_service))
    },
    visaRequirements () {
      return this.$store.state.visaRequirements
    },
    visaStepsForAClient () {
      const visaStepsForAClient = this.$store.state.visaStepsForAClient.filter(item => item.number_client_visa_step !== null)
      return visaStepsForAClient.sort((a, b) => Date.parse(a.number_client_visa_step) - Date.parse(b.number_client_visa_step))
    }
  },
  methods: {
    getRemainingDays (expiration_date_visa_requirement) {
      const expirationDate = new Date(expiration_date_visa_requirement)
      const todayDate = new Date()
      const diff = Math.floor((expirationDate - todayDate) / (1000 * 60 * 60 * 24))
      if (diff <= 0) return 'expirado'
      return `${diff} días`
    },
    updateMetadataVisaRequirement (data) {
      this.sidebarDataUpdateMetadataVisaRequirement = data
      this.$store.dispatch('fetchAddedServicesForAClientInmigration', this.id_client)
      this.toggleDataSidebarUpdateMetadataVisaRequirement(true)
    },
    toggleDataSidebarUpdateMetadataVisaRequirement (val = false) {
      this.addNewDataSidebarUpdateMetadataVisaRequirement = val
    },
    updateDataVisaRequirement (data) {
      this.sidebarDataUpdateVisaRequirement = data
      this.$store.dispatch('fetchAddedServicesForAClientInmigration', this.id_client)
      this.$store.dispatch('fetchVisaDocumentTypes')
      this.toggleDataSidebarUpdateVisaRequirement(true)
    },
    toggleDataSidebarUpdateVisaRequirement (val = false) {
      this.addNewDataSidebarUpdateVisaRequirement = val
    },
    downloadDocumentFiles (tr) {
      axios({
        method: 'get',
        url: `${axios.defaults.baseURL}visa-requirement/${tr.id_visa_requirement}/download-file`,
        responseType:'blob'
      })
        .then(response => {
          console.log(response) 
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          const contentType = response.headers['content-type']
          let fileName = tr.name_visa_document_type
          if (contentType === 'image/jpeg') {
            fileName += '.jpg'
          } else if (contentType === 'image/png') {
            fileName += '.png'
          } else if (contentType === 'application/pdf') {
            fileName += '.pdf'
          } else {
            fileName += '.zip'
          }
          link.setAttribute('download', fileName) //or any other extension
          document.body.appendChild(link)
          link.click()
        })
        .catch(err => {
          console.error(err)
          const mensaje_error = 'El Requerimiento de Visa no posee un Archivo asociado'
          if (typeof mensaje_error === 'string') {
            this.$vs.notify({
              title: 'Error',
              text: `${mensaje_error}`,
              color: 'warning',
              iconPack: 'feather',
              icon:'icon-x-circle',
              time: 6000
            })
          } else {
            const array_errors = Object.entries(mensaje_error)
            for (let i = 0; i < array_errors.length; i++) {
              this.$vs.notify({
                title: 'Error',
                text: `${array_errors[i][1][0]}`,
                iconPack: 'feather',
                icon: 'icon-x-circle',
                color: 'warning',
                time: 6000
              })
            }
          }
        })
    },

    confirmDeleteFileVisaRequirement (data) {
      this.$vs.loading()
      this.$store.dispatch('deleteFileVisaRequirement', data.id_visa_requirement)
        .then(() => {
          this.$store.dispatch('fetchVisaRequirementsForAClient', this.id_client)
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Archivo borrado',
            text: 'Se ha borrado el archivo del documento seleccionado',
            color: 'success',
            iconPack: 'feather',
            icon:'icon-check',
            time: 4000
          })
        })
        .catch(err => {
          this.$vs.loading.close()
          console.error(err)
          const mensaje_error = err.response.data.errors
          if (typeof mensaje_error === 'string') {
            this.$vs.notify({
              title: 'Error',
              text: `${mensaje_error}`,
              color: 'warning',
              iconPack: 'feather',
              icon:'icon-x-circle',
              time: 6000
            })
          } else {
            const array_errors = Object.entries(mensaje_error)
            for (let i = 0; i < array_errors.length; i++) {
              this.$vs.notify({
                title: 'Error',
                text: `${array_errors[i][1][0]}`,
                iconPack: 'feather',
                icon: 'icon-x-circle',
                color: 'warning',
                time: 6000
              })
            }
          }
        })
    },
    uploadFileVisaRequirement (data) {
      this.sidebarDataUploadFileVisaRequirement = data
      this.$store.dispatch('fetchAddedServicesForAClientInmigration', this.id_client)
      this.toggleDataSidebarUploadFileVisaRequirement(true)
    },
    toggleDataSidebarUploadFileVisaRequirement (val = false) {
      this.addNewDataSidebarUploadFileVisaRequirement = val
    },
    updateStatusVisaRequirement (data) {
      if (data.status_visa_requirement === 'Cargado' || data.status_visa_requirement === 'Sin Cargar') return
      const objStatus = {
        id_visa_requirement: data.id_visa_requirement,
        status: data.status_visa_requirement
      }
      this.$store.dispatch('updateStatusVisaRequirement', objStatus)
        .then(() => {
          this.$vs.notify({
            title: 'Estatus actualizado',
            color: 'success',
            iconPack: 'feather',
            icon:'icon-check'
          })
        })
        .catch(err => {
          this.$vs.loading.close()
          console.error(err)
          if (typeof err.response.data.errors === 'string') {
            this.$vs.notify({
              title: 'Error',
              text: `${err.response.data.errors}`,
              color: 'warning',
              iconPack: 'feather',
              icon:'icon-x-circle',
              time: 6000
            })
          } else {
            const array_errors = Object.entries(err.response.data.errors)
            for (let i = 0; i < array_errors.length; i++) {
              this.$vs.notify({
                title: 'Error',
                text: `${array_errors[i][1][0]}`,
                iconPack: 'feather',
                icon: 'icon-x-circle',
                color: 'warning',
                time: 6000
              })
            }
          }
        })
    },
    addNewVisaRequirements () {
      this.sidebarDataVisaRequirement = {}
      this.$store.dispatch('fetchAddedServicesForAClientInmigration', this.id_client)
      this.$store.dispatch('fetchVisaDocumentTypes')
      this.toggleDataSidebarVisaRequirement(true)
    },
    toggleDataSidebarVisaRequirement (val = false) {
      this.addNewDataSidebarVisaRequirement = val
    },
    updateCardCheckListDocuments () {
      this.$store.dispatch('fetchVisaRequirementsForAClient', this.id_client)
        .catch(err => {
          this.$vs.loading.close()
          console.error(err)
          if (typeof err.response.data.error === 'string') {
            this.$vs.notify({
              title: 'Error',
              text: `${err.response.data.error}`,
              color: 'warning',
              iconPack: 'feather',
              icon:'icon-x-circle',
              time: 6000
            })
          } else {
            const array_errors = Object.entries(err.response.data.error)
            for (let i = 0; i < array_errors.length; i++) {
              this.$vs.notify({
                title: 'Error',
                text: `${array_errors[i][1][0]}`,
                iconPack: 'feather',
                icon: 'icon-x-circle',
                color: 'warning',
                time: 6000
              })
            }
          }
        })
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    }
  },
  created () {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || this.$store.state.AppActiveUser
    this.id_client = this.userInfo.client_id
    this.$store.dispatch('fecthCustomerAddedServicesInmigration', this.userInfo)

    // Carga de DOCUMENTOS
    this.$store.dispatch('fetchVisaRequirementsForAClient', this.id_client)
      .catch(err => {
        this.$vs.loading.close()
        console.error(err)
        if (typeof err.response.data.error === 'string') {
          this.$vs.notify({
            title: 'Error',
            text: `${err.response.data.error}`,
            color: 'warning',
            iconPack: 'feather',
            icon:'icon-x-circle',
            time: 6000
          })
        } else {
          const array_errors = Object.entries(err.response.data.error)
          for (let i = 0; i < array_errors.length; i++) {
            this.$vs.notify({
              title: 'Error',
              text: `${array_errors[i][1][0]}`,
              iconPack: 'feather',
              icon: 'icon-x-circle',
              color: 'warning',
              time: 6000
            })
          }
        }
      })
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/vuexy/apps/simple-calendar.scss";

  .button-alignment {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .name-service-cell-width {
    width: 21em;
  }
  .visa-type-cell-width {
    width: 12em;
  }
  .action-cell-width {
    max-width: 5rem;
  }
  .product-name1 {
    max-width: 8rem;
  }
  .product-category1 {
    width: 7rem;
  }
  .product-category {
    width: 7rem;
  }
  .product-name {
      max-width: 12rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
</style>
